import { ContentSortFields, SortOrder } from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed, Ref } from "vue";
import { useI18n } from "vue-i18n";

export function useSortOrderItems(isGrouped: Ref<boolean>) {
    const { t } = useI18n();

    const sortOrderItems = computed(() => {
        const dateAndVersionItems = [
            {
                id: "Upload date ascending",
                title: t("shared.Upload date ascending"),
                value: {
                    field: ContentSortFields.uploadDate,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Upload date descending",
                title: t("shared.Upload date descending"),
                value: {
                    field: ContentSortFields.uploadDate,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Modification date ascending",
                title: t("shared.Modification date ascending"),
                value: {
                    field: ContentSortFields.modificationDate,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Modification date descending",
                title: t("shared.Modification date descending"),
                value: {
                    field: ContentSortFields.modificationDate,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Version descending",
                title: t("shared.Version descending"),
                value: {
                    field: ContentSortFields.version,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Version ascending",
                title: t("shared.Version ascending"),
                value: {
                    field: ContentSortFields.version,
                    order: SortOrder.asc,
                },
            },
        ];

        if (isGrouped.value) {
            return dateAndVersionItems;
        }

        return [
            {
                id: "Ranking",
                title: t("shared.Ranking"),
                value: {
                    field: ContentSortFields.score,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Title ascending",
                title: t("shared.Title ascending"),
                value: {
                    field: ContentSortFields.title,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Title descending",
                title: t("shared.Title descending"),
                value: {
                    field: ContentSortFields.title,
                    order: SortOrder.desc,
                },
            },
            ...dateAndVersionItems,
        ];
    });

    return { sortOrderItems };
}
